import React, { useState } from 'react';

import { useSelector } from 'react-redux';
import t from 'react-translate';
import { isEmpty } from 'underscore';

import { useAppDispatch } from 'redux/store';
import { setHasSeenAICourseSummaryModal, setSelectedCourse } from 'redux/actions/ai-course-creation';
import { getCurrentCourse, getCurrentCourseActiveAICreationCommand } from 'redux/selectors/course';
import { getCurrentInstitution } from 'redux/selectors/institutions';
import { getCurrentUserId } from 'redux/selectors/timeline';

import { AIButton } from './utils';
import CourseSummary from './course-summary';
import Flyout from './flyout';
import { config } from '@config/config.json';

const AiCreationAssistant = () => {
  const [showFlyout, setShowFlyout] = useState(false);
  const dispatch = useAppDispatch();
  const currentInstitution = useSelector(getCurrentInstitution);
  const currentCourse = useSelector(getCurrentCourse);
  const currentUserId = useSelector(getCurrentUserId);
  const currentAICreationCommand = useSelector(getCurrentCourseActiveAICreationCommand);
  const { isGenerating } = useSelector((state) => state.app.aiCourseCreation);
  const isAiCreationInProgress = !!currentAICreationCommand && (currentAICreationCommand?.inProgress || isGenerating);
  const shouldShowAiButton = currentInstitution.hasAiComponentGeneration && !isAiCreationInProgress;


  const handleNovoAiBtn = () => {
    setShowFlyout(true);
    dispatch(setSelectedCourse(null));
  };


  return (
    <div className='mt-5'>
      {shouldShowAiButton && (
        <AIButton
          text={t.LECTURE_PAGES.LHS.NOVO_AI.NOVOAI_CREATION_ASSISTANT()}
          onClick={handleNovoAiBtn}
          dataQa={config.pendo.novoAiCourseCreation.aiCreationAssistant}
        />
      )}

      {showFlyout && (
        <Flyout setShowFlyout={setShowFlyout} />
      )}
    </div>
  );
};

export default AiCreationAssistant;


